/**
 * Where each flag sits in assets/flags-sprite.webp. GENERATED by
 * scripts/build-flag-sprite.mjs — do not hand-edit; re-run that script.
 *
 * Generated rather than hand-kept for the same reason as lib/bundledFonts.ts: a
 * code listed here with no artwork behind it would render a slice of whatever
 * flag happens to be next to it, which is worse than rendering nothing.
 *
 * Positions are indices, not CSS. components/FlagIcon.tsx turns them into a
 * background-position — see the note there for why the percentages work out.
 */

export const SHEET = {
  cols: 16,
  rows: 17,
  /** The visible artwork inside each tile. */
  cellW: 60,
  cellH: 45,
  /** Edge-replicated padding around it, to stop neighbours bleeding in. */
  pad: 4,
} as const;

/** ISO-3166 (plus a few regional codes) → position in the sheet, row-major. */
export const FLAG_INDEX: Record<string, number> = {
  ad: 0,
  ae: 1,
  af: 2,
  ag: 3,
  ai: 4,
  al: 5,
  am: 6,
  ao: 7,
  aq: 8,
  ar: 9,
  arab: 10,
  as: 11,
  asean: 12,
  at: 13,
  au: 14,
  aw: 15,
  ax: 16,
  az: 17,
  ba: 18,
  bb: 19,
  bd: 20,
  be: 21,
  bf: 22,
  bg: 23,
  bh: 24,
  bi: 25,
  bj: 26,
  bl: 27,
  bm: 28,
  bn: 29,
  bo: 30,
  bq: 31,
  br: 32,
  bs: 33,
  bt: 34,
  bv: 35,
  bw: 36,
  by: 37,
  bz: 38,
  ca: 39,
  cc: 40,
  cd: 41,
  cefta: 42,
  cf: 43,
  cg: 44,
  ch: 45,
  ci: 46,
  ck: 47,
  cl: 48,
  cm: 49,
  cn: 50,
  co: 51,
  cp: 52,
  cr: 53,
  cu: 54,
  cv: 55,
  cw: 56,
  cx: 57,
  cy: 58,
  cz: 59,
  de: 60,
  dg: 61,
  dj: 62,
  dk: 63,
  dm: 64,
  do: 65,
  dz: 66,
  eac: 67,
  ec: 68,
  ee: 69,
  eg: 70,
  eh: 71,
  er: 72,
  es: 73,
  "es-ct": 74,
  "es-ga": 75,
  "es-pv": 76,
  et: 77,
  eu: 78,
  fi: 79,
  fj: 80,
  fk: 81,
  fm: 82,
  fo: 83,
  fr: 84,
  ga: 85,
  gb: 86,
  "gb-eng": 87,
  "gb-nir": 88,
  "gb-sct": 89,
  "gb-wls": 90,
  gd: 91,
  ge: 92,
  gf: 93,
  gg: 94,
  gh: 95,
  gi: 96,
  gl: 97,
  gm: 98,
  gn: 99,
  gp: 100,
  gq: 101,
  gr: 102,
  gs: 103,
  gt: 104,
  gu: 105,
  gw: 106,
  gy: 107,
  hk: 108,
  hm: 109,
  hn: 110,
  hr: 111,
  ht: 112,
  hu: 113,
  ic: 114,
  id: 115,
  ie: 116,
  il: 117,
  im: 118,
  in: 119,
  io: 120,
  iq: 121,
  ir: 122,
  is: 123,
  it: 124,
  je: 125,
  jm: 126,
  jo: 127,
  jp: 128,
  ke: 129,
  kg: 130,
  kh: 131,
  ki: 132,
  km: 133,
  kn: 134,
  kp: 135,
  kr: 136,
  kw: 137,
  ky: 138,
  kz: 139,
  la: 140,
  lb: 141,
  lc: 142,
  li: 143,
  lk: 144,
  lr: 145,
  ls: 146,
  lt: 147,
  lu: 148,
  lv: 149,
  ly: 150,
  ma: 151,
  mc: 152,
  md: 153,
  me: 154,
  mf: 155,
  mg: 156,
  mh: 157,
  mk: 158,
  ml: 159,
  mm: 160,
  mn: 161,
  mo: 162,
  mp: 163,
  mq: 164,
  mr: 165,
  ms: 166,
  mt: 167,
  mu: 168,
  mv: 169,
  mw: 170,
  mx: 171,
  my: 172,
  mz: 173,
  na: 174,
  nc: 175,
  ne: 176,
  nf: 177,
  ng: 178,
  ni: 179,
  nl: 180,
  no: 181,
  np: 182,
  nr: 183,
  nu: 184,
  nz: 185,
  om: 186,
  pa: 187,
  pc: 188,
  pe: 189,
  pf: 190,
  pg: 191,
  ph: 192,
  pk: 193,
  pl: 194,
  pm: 195,
  pn: 196,
  pr: 197,
  ps: 198,
  pt: 199,
  pw: 200,
  py: 201,
  qa: 202,
  re: 203,
  ro: 204,
  rs: 205,
  ru: 206,
  rw: 207,
  sa: 208,
  sb: 209,
  sc: 210,
  sd: 211,
  se: 212,
  sg: 213,
  sh: 214,
  "sh-ac": 215,
  "sh-hl": 216,
  "sh-ta": 217,
  si: 218,
  sj: 219,
  sk: 220,
  sl: 221,
  sm: 222,
  sn: 223,
  so: 224,
  sr: 225,
  ss: 226,
  st: 227,
  sv: 228,
  sx: 229,
  sy: 230,
  sz: 231,
  tc: 232,
  td: 233,
  tf: 234,
  tg: 235,
  th: 236,
  tj: 237,
  tk: 238,
  tl: 239,
  tm: 240,
  tn: 241,
  to: 242,
  tr: 243,
  tt: 244,
  tv: 245,
  tw: 246,
  tz: 247,
  ua: 248,
  ug: 249,
  um: 250,
  un: 251,
  us: 252,
  uy: 253,
  uz: 254,
  va: 255,
  vc: 256,
  ve: 257,
  vg: 258,
  vi: 259,
  vn: 260,
  vu: 261,
  wf: 262,
  ws: 263,
  xk: 264,
  xx: 265,
  ye: 266,
  yt: 267,
  za: 268,
  zm: 269,
  zw: 270,
};

/** Every code the sheet contains — 271 of them. */
export const FLAG_COUNT = 271;
